import type { ComponentProps } from 'react';
import { type VariantProps } from 'class-variance-authority';
import { buttonVariants } from '@/components/ui/buttonVariants';
import { cn } from '@/lib/utils';

type PatientPortalButtonProps = ComponentProps<'button'> &
  VariantProps<typeof buttonVariants>;

/**
 * ui/Button with its UNMASK_PROPS left off: on the patient pages even button
 * copy stays masked in replay (patientReplayMasking.test.tsx).
 */
export function PatientPortalButton({
  className,
  variant,
  size = 'md',
  type = 'button',
  ...props
}: PatientPortalButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        buttonVariants({ variant, size }),
        'font-patient-display text-base font-semibold',
        className
      )}
      {...props}
    />
  );
}
